import ComingSoon from "@/components/ComingSoon";
import { IMAGES } from "@/data/demo";
import { useSiteContent } from "@/lib/content";

const Boutique = () => {
  const c = useSiteContent();
  const titleOverride = c("boutique.title", "");
  return (
    <ComingSoon
      testId="boutique-page"
      overline={c("boutique.overline", "3M Match Pro — Le shop officiel")}
      title={
        titleOverride
          ? titleOverride.split("\n").map((l) => l.trim()).filter(Boolean).map((l, i) => <span key={i} className="text-white">{l}</span>)
          : [<span key="b" className="text-white">BOUTIQUE</span>]
      }
      description={c("boutique.description", "Maillots, tenues de stage et accessoires officiels 3M Match Pro : la boutique en ligne ouvrira prochainement. Laissez-nous un message pour être informé du lancement.")}
      image={IMAGES.jersey}
    />
  );
};

export default Boutique;
